"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleAutomationPopover = exports.dismissCard = exports.GetStartedCardActions = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _fluxActions = require("flux-actions");

var GetStartedCardActions = (0, _namespacedKeyMirror.default)({
  DISMISS_CARD: null,
  TOGGLE_AUTOMATION_POPOVER: null
}, 'ecomm-get-started-card');
exports.GetStartedCardActions = GetStartedCardActions;
var dismissCard = (0, _fluxActions.createAction)(GetStartedCardActions.DISMISS_CARD);
exports.dismissCard = dismissCard;
var toggleAutomationPopover = (0, _fluxActions.createAction)(GetStartedCardActions.TOGGLE_AUTOMATION_POPOVER, function (automationTipPopoverOpen) {
  return {
    automationTipPopoverOpen: automationTipPopoverOpen
  };
});
exports.toggleAutomationPopover = toggleAutomationPopover;